export const HOME_PUSH_NOTIFICATION = 'HOME_PUSH_NOTIFICATION';
export const HOME_DISMISS_ALL_NOTIFICATIONS = 'HOME_DISMISS_ALL_NOTIFICATIONS';
export const HOME_DISMISS_NOTIFICATION = 'HOME_DISMISS_NOTIFICATION';
export const HOME_SET_CURRENT_LEAD_BEGIN = 'HOME_SET_CURRENT_LEAD_BEGIN';
export const HOME_SET_CURRENT_LEAD_SUCCESS = 'HOME_SET_CURRENT_LEAD_SUCCESS';
export const HOME_SET_CURRENT_LEAD_FAILURE = 'HOME_SET_CURRENT_LEAD_FAILURE';
export const HOME_SET_CURRENT_LEAD_DISMISS_ERROR = 'HOME_SET_CURRENT_LEAD_DISMISS_ERROR';
export const HOME_CLEAR_CURRENT_LEAD = 'HOME_CLEAR_CURRENT_LEAD';
export const HOME_PUSH_LOG_LEVEL_CHANGE = 'HOME_PUSH_LOG_LEVEL_CHANGE';
export const HOME_UPDATE_SERVICE_STATUS = 'HOME_UPDATE_SERVICE_STATUS';
export const RESET_PASSWORD_VERIFY_ACCOUNT_BEGIN = 'RESET_PASSWORD_VERIFY_ACCOUNT_BEGIN';
export const RESET_PASSWORD_VERIFY_ACCOUNT_SUCCESS = 'RESET_PASSWORD_VERIFY_ACCOUNT_SUCCESS';
export const RESET_PASSWORD_VERIFY_ACCOUNT_ERROR = 'RESET_PASSWORD_VERIFY_ACCOUNT_ERROR';
export const VALIDATE_RESTORE_PASSWORD_BEGIN = 'VALIDATE_RESTORE_PASSWORD_BEGIN';
export const VALIDATE_RESTORE_PASSWORD_SUCCESS = 'VALIDATE_RESTORE_PASSWORD_SUCCESS'
export const VALIDATE_RESTORE_PASSWORD_FAILURE = 'VALIDATE_RESTORE_PASSWORD_FAILRE'
export const VALIDATE_RESTORE_PASSWORD_DISMISS_ERROR = 'VALIDATE_RESTORE_PASSWOR_DISMISS_ERROR'
export const RESET_PASSWORD_VERIFY_ACCOUNT_CLEAR = 'RESET_PASSWORD_VERIFY_ACCOUNT_CLEAR';
export const SAVE_NOTIFICATIONS = 'SAVE_NOTIFICATIONS'
export const APPEND_NOTIFICATIONS = 'APPEND_NOTIFICATIONS'
export const UPDATE_NOTIFICATIONS_LIST = "UPDATE_NOTIFICATIONS_LIST";
export const NOTIFICATION_SECTION = { GENERAL: 'general', WHATSAPP: 'whatsapp' }
export const NOTIFICATION_EVENT_REASON = { MESSAGE_ENTRY: 'messageEntry', CALL_ENTRY: 'callEntry', CALL_EXIT: 'callExit', CALL_HISTORY: 'callHistory' }
export const WHATSAPP_MESSAGES_EVENT_REASONS = [ NOTIFICATION_EVENT_REASON.MESSAGE_ENTRY, NOTIFICATION_EVENT_REASON.CALL_ENTRY ].join(',')
export const WHATSAPP_CALLS_EVENT_REASONS = [ NOTIFICATION_EVENT_REASON.CALL_HISTORY, NOTIFICATION_EVENT_REASON.CALL_EXIT ].join(',')
